import { Icon } from '@aws-amplify/ui-react';
import { MdOutlineAttachMoney } from 'react-icons/md';
const DollarIcon = ({ color }: { color: string }) => {
  return <Icon ariaLabel="Javascript" as={MdOutlineAttachMoney} />;
};
export default DollarIcon;
